import Teachers from '@/views/Teachers'
import TeacherInfo from '@/views/TeacherInfo'

export default [
  {
    path: '/organization/:organizationId/teachers',
    name: 'teachers',
    component: Teachers,
    props: true,
    meta: {
      menuItemIndex: '4',
      title:'Teachers'
    }
  },
  {
    path: '/organization/:organizationId/teachers/new',
    name: 'teachers-new',
    component: Teachers,
    props: (route) => {
      return {
        organizationId: route.params.organizationId,
        new: 'email-invite'
      }
    },
    meta: {
      menuItemIndex: '4',
      title:'Create Teacher'
    }
  },
  {
    path: '/organization/:organizationId/teachers/:teacherId',
    name: 'teacher-details',
    component: TeacherInfo,
    props: true,
    meta: {
      menuItemIndex: '4',
      title:'Teacher Details'
    }
  }
]
